import React from "react";
import { useParams, useLocation } from "react-router-dom";
import MasterSuiteWorkspace from "../../components/mastersuite/MasterSuiteWorkspace";

// Full-page read-only View Master Suite (workflow canvas + read-only table).
function MasterSuiteViewPage() {
  const { name } = useParams();
  const location = useLocation();
  const suiteName = decodeURIComponent(name || "");
  return (
    <MasterSuiteWorkspace
      mode="view"
      name={suiteName}
      defaultEnvironment={location.state?.defaultEnvironment}
    />
  );
}

export default MasterSuiteViewPage;
